import React from "react";
import styles from "./Heading.module.scss";
import { H2 } from "../Html/Html";

const Heading = props => (
  <H2 className={styles.heading + " " + props.className}>{props.text}</H2>
);

export default Heading;
